import styled from 'styled-components';
import Button from '@nubank/nuds-web/components/Button/Button';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

export const CloseButton = styled(Button)`
  width: ${spacing('8x')};
  height: ${spacing('8x')};
`;
